// AI Upgraded Module
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@client/app/modules/translate.module';
import { HotkeyModule } from 'angular2-hotkeys';
import { NgClickOutsideDelayOutsideDirective, NgClickOutsideDirective } from 'ng-click-outside2';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSharedComponentsModule, TableModule } from '@monsido/angular-shared-components';
import { SpotlightComponent } from './components/spotlight/spotlight.component';
import { SpotlightSearchComponent } from './components/search/search.component';
import { NotificationResultComponent } from './components/search/notification-result/notification-result.component';
import { UnifiedHotkeysCheatsheetComponent } from './components/unified-hotkeys/unified-hotkeys-cheatsheet.component';
import { HotkeysInitService } from './services/hotkeys-init.service';


export function initializeAngularJSHotkeys (hotkeyInitService: HotkeysInitService): () => void {
    return () => {
        hotkeyInitService.initializeApp();
    };
}

@NgModule({
    imports: [
        CommonModule,
        HotkeyModule.forRoot(),
        NgClickOutsideDelayOutsideDirective,
        NgClickOutsideDirective,
        TranslateModule,
        NgbTooltipModule,
        AngularSharedComponentsModule,
        FormsModule,
        TableModule,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (initializeAngularJSHotkeys)(inject(HotkeysInitService));
            return initializerFn();
        }),
    ],
    declarations: [
        SpotlightComponent,
        SpotlightSearchComponent,
        NotificationResultComponent,
        UnifiedHotkeysCheatsheetComponent,
    ],
    exports: [
        SpotlightComponent,
        UnifiedHotkeysCheatsheetComponent,
    ],
})
export class SpotlightModule {}
